import { Button } from '@chakra-ui/button'
import { useDisclosure } from '@chakra-ui/hooks'
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
} from '@chakra-ui/modal'
import { useRef, useState } from 'react'
import { api } from '../../../services/api'
import { useMutation, useQueryClient } from 'react-query'
import InputFloating from '../../../components/InputFloating'
import { Flex, useToast } from '@chakra-ui/react'

async function confirmar({ id, valor_produto }) {
  const response = await api.post(
    '/site/v2/pedido/atualiza-pendencia-desconto',
    {
      id_usuario: id,
      valor_desconto: valor_produto,
    }
  )

  console.log(response.data)

  return response.data
}

export function Confirmar({ id }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = useRef()
  const referenceValue = useRef()
  const queryClient = useQueryClient()

  const toast = useToast({
    position: 'top',
    duration: 5000,
    isClosable: true,
  })

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: async ({ valor_produto }) =>
      confirmar({ id: id, valor_produto }),
    onSuccess: () => {
      console.log('sucesso')
      onClose()
      queryClient.invalidateQueries('listDiscount')

      toast({
        title: 'Desconto confirmado com sucesso',
        status: 'success',
        description: 'O desconto foi confirmado com sucesso',
      })
    },
    onError: () => {
      console.log('erro')
      toast({
        title: 'Erro ao aprovar desconto',
        status: 'error',
        description: 'Ocorreu um erro ao aprovar o desconto',
      })
    },
  })

  async function handleConfirm() {
    const value = referenceValue.current.value.replace(',', '.')

    try {
      await mutateAsync({
        valor_produto: value,
      })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <Button colorScheme="green" onClick={onOpen}>
        Confirmar
      </Button>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent as="form">
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirmar desconto
            </AlertDialogHeader>

            <AlertDialogBody>
              Para confirmar o desconto, você precisa informar o valor do
              produto.
              <Flex mt={4}>
                <InputFloating
                  label="Valor do produto"
                  placeholder="Exemplo: 10,00"
                  type="number"
                  name="valor"
                  bgColor="transparent"
                  ref={referenceValue}
                />
              </Flex>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancelar
              </Button>
              <Button
                colorScheme="blue"
                onClick={handleConfirm}
                ml={3}
                isLoading={isLoading}
              >
                Confirmar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
